import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-stock",
  "use": "icon-stock-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-stock\"><defs><style type=\"text/css\"></style></defs><path d=\"M896 640h-42.666667v-89.6l-320-320L213.333333 550.4V810.666667h341.333334v42.666666H170.666667v-277.333333H128L533.333333 170.666667l405.333334 405.333333h-42.666667V640z m0 128v128h-128v-128h128z m-170.666667 0v128h-128v-128h128z m85.333334-170.666667v128h-128v-128h128z m-42.666667 42.666667h-42.666667v42.666667h42.666667v-42.666667z m-85.333333 170.666667h-42.666667v42.666666h42.666667v-42.666666z m170.666666 0h-42.666666v42.666666h42.666666v-42.666666z\" fill=\"#f4ea2a\" p-id=\"2157\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/stock.svg
// module id = t+aG
// module chunks = 132